import React, {useContext, useEffect} from 'react';
import {FormattedMessage, injectIntl} from "react-intl";

import {useFormikContext} from "formik";

import FormControlLabel from "components/radioGroup/FormControlLabel";
import RadioGroup from "components/radioGroup/RadioGroup";
import SelectTitle from "components/radioGroup/SelectTitle";

import {ListContext} from "components/List/context/ListContext";

import {DeliveryPresetsByDiscr, ShippingMethodsDiscr} from "utils/ShippingMethods";
import {ShippingMethodFormContext} from "views/shippingMethods/components/ShippingMethodForm/context/ShippingMethodFormContext";

function MethodTypeField(props) {
    const {values, setFieldValue, setFieldTouched} = useFormikContext();
    const {selectedItem} = useContext(ListContext);
    const {setDiscr} = useContext(ShippingMethodFormContext);

    // alphabetical in the user's language
    const label = (discr) => props.intl.formatMessage({id: `shippingMethods.discr.${discr}`});
    const sortedDiscrs = ShippingMethodsDiscr.toArray().sort((first, second) => label(first).localeCompare(label(second), props.intl.locale));

    return (
        <>
            <SelectTitle
                titleTranslationKey={'shippingMethods.form.field.discr.label'}
                required={true}
            />
            <RadioGroup
                alignListWithButton
                placeholder={props.intl.formatMessage({id: 'shippingMethods.form.field.discr.placeholder'})}
                selectedValueLabel={values.discr ? props.intl.formatMessage({id: `shippingMethods.discr.${values.discr}`}) : ''}
                name={'discr'}
                disabled={selectedItem !== null}
                value={values.discr}
                onClickAway={() => setFieldTouched('discr')}
                onChange={(event, value) => {
                    setFieldValue('discr', value);
                    setDiscr(value);

                    const preset = DeliveryPresetsByDiscr[value];
                    if (preset) {
                        setFieldValue('deliveryMode', preset.deliveryMode);
                        setFieldValue('carrier', preset.carrier);
                    }
                }}
            >
                {sortedDiscrs.map((discr, index) => (
                    <FormControlLabel
                        key={index}
                        value={discr}
                        label={<FormattedMessage id={`shippingMethods.discr.${discr}`} />}
                    />
                ))}
            </RadioGroup>
        </>
    );
}

export default injectIntl(MethodTypeField);
